import { GET_FEATURE_FLAGS } from '@/utils/store/actionTypes'
import { SET_FEATURE_FLAGS } from '@/utils/store/mutationTypes'

import logger from '@/utils/logger'

export default {
  async [GET_FEATURE_FLAGS] ({ rootState, commit }) {
    try {
      const userId = rootState.auth.userId

      const response = await this.$axios.$get(`${process.env.UNLEASH_API_URL}${userId ? `?userId=${userId}` : ''}`, {
        headers: {
          Authorization: process.env.UNLEASH_API_TOKEN,
          'OTA-External': 'true' // Bypass axios plugin Authorization Header override
        }
      })

      commit(SET_FEATURE_FLAGS, { flags: response })
    } catch (error) {
      logger.error({
        message: 'Error occurred while fetching feature flags',
        error,
        context: 'feature-flags'
      })
    }
  }
}
